import { getFilterIndicator } from "../helpers";
import type { ComparisonType } from "../types";

import type { FilterStrategy } from "./types";

const COMP_SYMBOLS: Record<ComparisonType, string> = {
  eq: "=",
  gte: "≥",
  lte: "≤",
};

export const numberRangeStrategy: FilterStrategy = {
  search(filterType, ctx, out) {
    if (ctx.parsedNumber === null) return;
    const score = ctx.looksLikeDate ? 40 : 80;
    if (ctx.parsedNumberQuery?.comparison) {
      const cmp = ctx.parsedNumberQuery.comparison;
      out.push({
        filterKey: filterType.filterKey,
        filterLabel: filterType.label,
        optionValue: `__number_range_${cmp}__`,
        optionLabel: `${COMP_SYMBOLS[cmp]} ${ctx.parsedNumber}`,
        type: filterType.type,
        comparison: cmp,
        numericValue: ctx.parsedNumber,
        score,
        indicator: getFilterIndicator(filterType, true),
      });
      return;
    }
    const comparisons: { comparison: ComparisonType; symbol: string }[] = [
      { comparison: "eq", symbol: "=" },
      { comparison: "gte", symbol: "≥" },
      { comparison: "lte", symbol: "≤" },
    ];
    for (const c of comparisons) {
      out.push({
        filterKey: filterType.filterKey,
        filterLabel: filterType.label,
        optionValue: `__number_range_${c.comparison}__`,
        optionLabel: `${c.symbol} ${ctx.parsedNumber}`,
        type: filterType.type,
        comparison: c.comparison,
        numericValue: ctx.parsedNumber,
        score,
        indicator: getFilterIndicator(filterType, true),
      });
    }
  },
  isSelected(currentValue, _optionValue, comparison, numericValue) {
    if (
      Array.isArray(currentValue) &&
      currentValue.length === 2 &&
      comparison &&
      numericValue !== undefined
    ) {
      if (comparison === "eq") {
        return (
          currentValue[0] === numericValue && currentValue[1] === numericValue
        );
      }
      if (comparison === "gte") {
        return currentValue[0] === numericValue && currentValue[1] === null;
      }
      if (comparison === "lte") {
        return currentValue[0] === null && currentValue[1] === numericValue;
      }
    }
    return false;
  },
  toggle(result) {
    if (result.comparison && result.numericValue !== undefined) {
      let rangeValue: (number | null)[];
      if (result.comparison === "eq") {
        rangeValue = [result.numericValue, result.numericValue];
      } else if (result.comparison === "gte") {
        rangeValue = [result.numericValue, null];
      } else {
        rangeValue = [null, result.numericValue];
      }
      return { value: rangeValue };
    }
    return { value: result.optionValue };
  },
};
